import { useEffect, useRef, useState } from "react";
import useClickOutside from "../../../Hooks/useClickOutside";
import GeneralService from "../../../Services/Dashboard/GeneralService";
import InvoiceInput from "../Invoice/InvoiceInput";

const Banks = ({ setStates = () => {}, ...props }) => {
  useEffect(() => {}, []);

  return (
    <>
      <CustomSelect
        className="mb-5 mt-2 w-full"
        setStates={setStates}
        {...props}
      />
    </>
  );
};

const CustomSelect = ({ setStates, top, ...props }) => {
  const [search, setSearch] = useState("");
  const [field, setField] = useState(null);
  const [data, setData] = useState([]);
  const details = useRef();
  const check = useRef();

  const loadOptions = async (inputValue = "") => {
    //still in test might break not sure yet
    try {
      const response = await GeneralService.banks();
      const data = response?.data?.data?.data?.filter((v) => {
        if (inputValue === "") {
          return true;
        }
        return v.name.toLowerCase().includes(inputValue.toLowerCase());
      });
      setData(data ?? []);
    } catch (error) {
      console.error(error);
    }
  };

  useClickOutside(details, () => {
    details.current.removeAttribute("open");
  });

  useEffect(() => {
    loadOptions(search);
  }, [search]);

  const isTop = top ? "bottom-0 mb-16" : "mb-2 ";

  return (
    <div>
      <label
        className="mb-1 w-full text-base capitalize text-gray-700"
        style={{ fontWeight: 700, fontSize: "18px" }}
      >
        {props.label}
      </label>
      <details
        className="relative text-[12px] font-[700] leading-[18px]"
        ref={details}
      >
        <summary className="form-input w-full list-none border bg-transparent px-4 py-5 text-sm font-semibold tracking-wide text-gray-500 placeholder:capitalize  placeholder:text-gray-200 focus:border-purple-800 focus:outline-none">
          {field ?? "Search for Bank"}
        </summary>
        <ul
          className={`absolute  z-40  max-h-80 w-full overflow-y-auto bg-white shadow-lg ${isTop}`}
        >
          <li className="sticky top-0 px-6">
            <InvoiceInput
              normalize
              placeholder="Search for Bank"
              type="text"
              onChange={(e) => {
                setSearch(e.target.value);
                setField(null);
                check.current.checked = true;
              }}
              value={search}
            />
            <input
              type="radio"
              ref={check}
              {...props}
              className="hidden"
              value=""
            />
          </li>
          {data.map((v, i) => (
            <li key={i} className="w-full">
              <label
                onClick={() => {
                  setField(v.name);
                  details.current.removeAttribute("open");
                }}
              >
                <input
                  type="radio"
                  {...props}
                  className="peer hidden"
                  value={v.name}
                />
                <span className="inline-block w-full cursor-pointer px-6 py-2 text-black hover:bg-blue-500 hover:text-white peer-checked:bg-blue-700 peer-checked:text-white">
                  {v.name}
                </span>
              </label>
            </li>
          ))}
          {data.length <= 0 && (
            <li className="inline-block cursor-pointer px-6 py-2 text-black">
              No Data Available yet
            </li>
          )}
        </ul>
      </details>
    </div>
  );
};

export default Banks;
